import React from 'react';
import { Target, KeySquare, Palette, Sparkles } from 'lucide-react';

const steps = [
  {
    icon: Target,
    title: 'Enter Content',
    description: 'Input your video title and description for context-aware tags.'
  },
  {
    icon: KeySquare,
    title: 'Choose Category',
    description: 'Select your video category and tag style preferences.'
  },
  {
    icon: Palette,
    title: 'Generate Tags',
    description: 'Our AI creates optimized tags based on your content.'
  },
  {
    icon: Sparkles,
    title: 'Copy & Use',
    description: 'Copy the generated tags to your YouTube video settings.'
  }
];

export default function YouTubeHowItWorks() {
  return (
    <section className="py-20 bg-red-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          How Our YouTube Tag Generator Works
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-red-200"></div>
              )}
              <div className="relative text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 mb-4">
                  <step.icon className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}